import { Stack, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" spacing={4}>
      <Typography variant="h1">{t('errors.thisPageDoesNotExist')}</Typography>
      <Link to="/">{t('goBackToHome')}</Link>
    </Stack>
  );
};

export default NotFound;
